import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import memberStatuses from '../../_constants/memberStatuses'
import { connect } from 'react-redux'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class StatusSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
    };
  }

  handleChange = e => {
    this.props.onChange(e.value);
  }

  render() {
    const { style } = this.props;
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
      menuList: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
      option: (provided, state) => ({
        ...provided,
        padding: 10,
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#6d6d6d',
      }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#fff',
        borderRadius: 7,
        height: 40,
        boxShadow: 'none',
        paddingRight: '12',
        border: 'this solid #b4b4b4',
        marginBottom: 15
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading, data } = this.state;
    const { disabled, required } = this.props;

    const { user } = this.props;
    
    return (
      <div>
        {!loading &&
          <Select
            isDisabled={disabled}
            placeholder=""
            styles={customStyles}
            options={user && (user.role === 0 || user.permissions.includes(2)) ? memberStatuses.map(elm => ({ "label": elm.name, "value": elm.id })) : memberStatuses.filter(el => el.id !== 5).map(elm => ({ "label": elm.name, "value": elm.id }))}
            onChange={this.handleChange}
            value={this.props.defaultValue}
            className={required ? "select required" : "select"}
          />
        }
      </div>
    );
  }
}
// export default StatusSelect;


function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedStatusSelect = connect(mapStateToProps)(StatusSelect);
export { connectedStatusSelect as StatusSelect };
